import { makeStyles } from '@material-ui/core'
import { BaseColors } from '../../../configs/types'

const buildStyles = makeStyles(() => ({
  footer: (props: { baseColors: BaseColors; isMobile: boolean }) => {
    return {
      display: 'flex',
      justifyContent: props.isMobile ? 'center' : 'flex-end',
      marginTop: 'auto',
      padding: '20px 60px',
    }
  },

  footerText: (props: { baseColors: BaseColors }) => {
    return {
      textDecoration: 'none',
      fontSize: '14px',
      letterSpacing: '1px',
      fontWeight: 'bold',
      color: props.baseColors.primary,
      '&:hover': {
        textDecoration: 'none',
      },
    }
  },
}))

export default buildStyles
